import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ message, show, onClose }) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 2600);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <div 
      className={`toast ${show ? 'show' : ''}`} 
      role="status" 
      aria-live="polite" 
      aria-atomic="true"
    >
      {message}
    </div>
  );
}

export default Toast;
